const { trackGtm4 } = require('util/functions');

module.exports = {
	init() {
		this.root.querySelectorAll('.left-menu--link')?.forEach(element => {
			element.addEventListener('click', this.gtmTracking.bind(this));
		});
	},
	gtmTracking({ target }) {
		const title = this.root.querySelector('.tbe-journey--title')
			? this.root.querySelector('.tbe-journey--title').innerHTML.trim()
			: 'Title not set';
		const linkText = target.innerHTML.trim();
		const linkUrl = target.href;

		trackGtm4({
			event: 'GA4_event_c_content_navigation_click',
			widget_name: 'V3-Legal-information',
			widget_title: title,
			widget_type: 'article',
			link_text: linkText,
			link_url: linkUrl,
			interaction_type: 'side navigation',
		});
	},
};
